import { render, staticRenderFns } from "./UserIdentifications.vue?vue&type=template&id=bab1f33a&scoped=true"
import script from "./UserIdentifications.vue?vue&type=script&lang=js"
export * from "./UserIdentifications.vue?vue&type=script&lang=js"
import style0 from "./UserIdentifications.vue?vue&type=style&index=0&id=bab1f33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab1f33a",
  null
  
)

export default component.exports